





































































































import masterdata, {
    ULCFormandRequest,
    ListContentResponseModelULC,
    KnownValuesResponseModelULC,
    CompanyListItem,
    ChildListElement,
    ListElement,
} from '@/services/masterdata';
import ShowMDResponse from '@/components/masterData/components/ShowMDResponse.vue';
import step1BasicCompanyInfo from '@/components/masterData/components/step1BasicCompanyInfo.vue';
import step2PaymentInfoNCnULC from '@/components/masterData/components/step2PaymentInfoNCnULC.vue';

export default {
    components: {
        'md-response': ShowMDResponse,
        'md-step1': step1BasicCompanyInfo,
        'md-step2': step2PaymentInfoNCnULC,
    },
    data(this: any): any {
        return {
            companycode: 4826,
            societa: 21,
            societaUser: 5,
            resivedData: false,
            step: 0,
            nazione: '',
            companyListItemList: [] as CompanyListItem[] | undefined,
            form: {},
            lists: [] as ListContentResponseModelULC[],
            ulc: {} as ULCFormandRequest,
            errors: [],
            Outdated: false,
            response: null,
            formstyle: {
                labelwidth: '170px',
                labelposition: 'right',
            },
            pdfFile: null,
        };
    },
    methods: {
        async getCompanies(this: any) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            try {
                this.companyListItemList = await masterdata.getULCCompanyList(this.companycode, this.societa, this.societaUser);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.CompanyGetFailed');
                return;
            }
            this.resivedData = true;
            loading.close();
            if (this.companyListItemList.length === 1) {
                this.getData(-1, this.companyListItemList[0]);
            }
        },
        async getData(this: any, index: any, row: CompanyListItem) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let item: KnownValuesResponseModelULC | undefined;
            let lists: ListContentResponseModelULC | undefined;
            try {
                item = await masterdata.getULCKnownValues(this.companycode, this.societa, this.societaUser, row.ClienteFornitoreCodice, row.SocietaCollegamento);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.CompanyGetFailed', false);
                return;
            }
            try {
                lists = await masterdata.getCustomerListContent(this.companycode, this.societa, this.societaUser);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.ListGetFailed', false);
                return;
            }
            loading.close();
            if (item !== null && lists !== null) {
                this.ulc = item;
                this.ulc.SocietaCollegamento = row.SocietaCollegamento;
                this.ulc.ClienteFornitoreCodice = row.ClienteFornitoreCodice;
                this.Outdated = row.Outdated;
                this.lists = lists;
                this.ulc.CreditLimit = this.ulc.CreditLimit;
                this.step += 1;
                this.nazione = this.ulc.Lingua;
                if (this.lists.Lingua.filter((i: ListElement) => i.Codice === this.ulc.Lingua).length === 0) {
                    this.ulc.Lingua = 'GB';
                }
                this.lists.GreenMove.sort((a: ListElement, b: ListElement) => +a.Codice.split(' ', 1)[0] - +b.Codice.split(' ', 1)[0]);
                const greenMoveCode = this.lists.GreenMove.find((a: ListElement) => a.Codice.startsWith(String(Number(this.ulc.GreenMove))));
                if (greenMoveCode != null) {
                    this.ulc.GreenMove = greenMoveCode.Codice;
                }
                if (!this.Outdated) {
                    this.onSubmit();
                }
            } else {
                this.$alert(this.$t('masterData.NewCustomerFailedMessage'), this.$t('masterData.NewCustomerFailedTitel'), {
                    type: 'error',
                    confirmButtonText: 'OK',
                    center: true,
                });
            }
        },
        async onSubmit(this: any) {
            const loading = this.$loading({ lock: true, text: 'Loading', background: 'rgba(0, 0, 0, 0.7)' });
            this.ulc.CreditLimit = `${this.ulc.CreditLimit}`;
            if (this.Outdated) {
                let fileByteArray: any[] | null = null;
                let filename: string | null = null;
                if (this.pdfFile != null && this.Outdated) {
                    fileByteArray = [];
                    filename = this.pdfFile.name;
                    try {
                        const array = new Uint8Array(await masterdata.readUploadedFileAsArrayBuffer(this.pdfFile.raw));
                        for (let i = 0; i < array.length; i += 1) {
                            fileByteArray.push(array[i]);
                        }
                    } catch (e) {
                        console.warn(e.message);
                        return;
                    }
                }
                this.ulc.pdfFile = fileByteArray;
                this.ulc.pdfFileName = filename;

                if (this.ulc.Payment !== 'RB') {
                    this.ulc.Iban = null;
                    this.ulc.pdfFile = null;
                    this.ulc.pdfFileName = null;
                }
            }
            this.error = [];
            let response;
            try {
                response = await masterdata.sendDataCustomer(this.companycode, this.societa, this.societaUser, this.ulc);
            } catch (error) {
                if (error.response != null && Array.isArray(error.response.data)) {
                    this.errors = error.response.data;
                    loading.close();
                } else {
                    masterdata.errorMessageAlert(this, error, loading, 'masterData.NewCustomerFailedTitel', 'masterData.NewCustomerFailedMessage', false);
                }
                return;
            }
            loading.close();
            this.response = response;
        },
        async nextStep(this: any) {
            this.step += 1;
            if (this.step === 3) {
                this.onSubmit();
            }
        },
    },
    mounted(this: any) {
        this.companycode = this.$route.query.companycode;
        this.societa = this.$route.query.societa;
        this.societaUser = this.$route.query.societaUser;
        this.getCompanies();
    },
};
